/**
 * Quiet custom-cake block. Keeps the 72-hour notice. No cake emoji.
 */

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DEFAULT_CAKE_QUOTE } from '../../utils/homepageSectionDefaults';
import type { PreviewContact } from './usePreviewHomeData';

export default function PreviewCustomCakes({
  images,
  contact,
}: {
  images: string[];
  contact: PreviewContact;
}) {
  const tel = contact.phone.replace(/\D/g, '');

  return (
    <section className="bg-gray-950 text-white section-padding">
      <div className="container-custom">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-amber-300">Custom cakes</p>
            <h2 className="mt-2 font-display text-3xl font-bold md:text-4xl">
              {DEFAULT_CAKE_QUOTE.cake_quote_title}
            </h2>
            <p className="mt-4 text-lg text-gray-300">{DEFAULT_CAKE_QUOTE.cake_quote_description}</p>
            <p className="mt-4 inline-block rounded-full border border-amber-400/40 bg-amber-400/10 px-4 py-2 text-sm text-amber-200">
              {DEFAULT_CAKE_QUOTE.cake_quote_notice}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={`tel:${tel}`} className="btn-primary">
                Call {contact.phone}
              </a>
              <Link
                to="/cake-request"
                className="btn-outline border-white text-white hover:bg-white hover:text-gray-900"
              >
                Cake request
              </Link>
            </div>
          </motion.div>

          <div className="grid grid-cols-2 gap-3">
            {images.slice(0, 4).map((src) => (
              <img
                key={src}
                src={src}
                alt="Custom cake from Nanny B's Bakery"
                className="aspect-square w-full rounded-2xl object-cover"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
